import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
const record = () =>
    import ("../views/record.vue");
const address = () =>
    import ("../views/address.vue");
const Home = () =>
    import ("../views/Home.vue");
const roadmap = () =>
    import ("../views/roadmap.vue");
const myroad = () =>
    import ("../views/myroad.vue");
const map = () =>
    import ("../components/map.vue");
const auto = () =>
    import ("../views/automatic.vue");
const road = () =>
    import ("../views/road.vue");
const login = () =>
    import("../views/login.vue");
const iframe = () =>
    import ("../views/h5.vue");
const signUp = () =>
    import ("../views/signUp.vue");
const pwdBack = () =>
    import ("../views/pwdBack.vue");
const activeRule = () =>
    import ("../views/activeRule.vue");
const cdKey = () =>
    import ("../views/cdKey.vue");

Vue.use(VueRouter);

const routes = [{
        path: "/home",
        name: "Home",
        component: Home,
    },
    {
        path: "/map",
        name: "Amap",
        component: map,
    },
    {
        path: "/record",
        name: "record",
        component: record,
    },
    {
        path: "/map",
        name: "map",
        component: map,
    },
    {
        path: "/address",
        name: "myaddress",
        component: address,
    },
    {
        path: "/road",
        name: "road",
        component: road,
    },
    {
        path: "/roadmap",
        name: "roadmap",
        component: roadmap,
    },
    {
        path: "/myroad",
        name: "myroad",
        component: myroad,
    },
    {
        path: "/login",
        name: "login",
        component: login,
    },
    {
        path: "/iframe",
        name: "iframe",
        component: iframe,
    },
    {
        path: "/signUp",
        name: "signUp",
        component: signUp,
    },
    {
        path: "/pwdBack",
        name: "pwdBack",
        component: pwdBack,
    },
    {
        path: "/activeRule",
        name: "activeRule",
        component: activeRule,
    },
    {
        path: "/cdKey",
        name: "cdKey",
        component: cdKey,
    },
    {
        path: "/auto",
        name: "auto",
        component: auto,
    }, {
        path: "/",
        name: "index",
        component: index,
    },
];

const router = new VueRouter({
    routes,
});

export default router;